import { render, staticRenderFns } from "./InitiativeTaxonomy.vue?vue&type=template&id=4a9f8364&"
import script from "./InitiativeTaxonomy.vue?vue&type=script&lang=js&"
export * from "./InitiativeTaxonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports